import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-remain",
  "use": "icon-icon-remain-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-remain\"><path d=\"M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m0 76.032a372.032 372.032 0 0 0 0 743.936A372.032 372.032 0 0 0 512 140.032zM536 448c4.416 0 8 3.584 8 8v272a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-272c0-4.416 3.584-8 8-8zM512 288A48 48 0 1 1 512 384a48 48 0 0 1 0-96z\" p-id=\"7203\" fill=\"#2970FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol